import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { SERVER_URL, AUTH_STORAGE_KEY } from "../socket";
import { loadSliderImages } from "../api/sliderApi";
import brandLogo from "../TimeEdgeIcon.png";
import "../styles.css";
import loginBg1 from "../bgimage11.jpg";
import loginBg2 from "../bgimage12.jpg";
import Header from "./Header";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Select from "react-select";
const CORPORATE_DOMAIN = "@krivaone.com";
const STEP_COUNT = 5;

const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda",
  "Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain",
  "Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan",
  "Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria",
  "Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada",
  "Central African Republic","Chad","Chile","China","Colombia","Comoros",
  "Congo","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark",
  "Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador",
  "Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Fiji",
  "Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece",
  "Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras",
  "Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel",
  "Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Kuwait",
  "Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya",
  "Liechtenstein","Lithuania","Luxembourg","Madagascar","Malawi","Malaysia",
  "Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius",
  "Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco",
  "Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Zealand",
  "Nicaragua","Niger","Nigeria","North Korea","North Macedonia","Norway","Oman",
  "Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru",
  "Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda",
  "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines",
  "Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal",
  "Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia",
  "Solomon Islands","Somalia","South Africa","South Korea","South Sudan",
  "Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria",
  "Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga",
  "Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda",
  "Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay",
  "Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Yemen",
  "Zambia","Zimbabwe",
];

const isAtLeast12YearsOld = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
  return age >= 12;
};

function RegisterPage() {
  const [step, setStep]                   = useState(0);
  const [loading, setLoading]             = useState(false);
  const [message, setMessage]             = useState("");
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [emailAvailable, setEmailAvailable] = useState(null);
  const [success, setSuccess]             = useState(false);

  // slider
  const fallbackImages = [loginBg1, loginBg2];
  const [sliderImages, setSliderImages]   = useState([]);
  const [adIndex, setAdIndex]             = useState(0);
const countryOptions = COUNTRIES.map((country) => ({
  value: country,
  label: country,
}));
  useEffect(() => {
    const loadImages = async () => {
      try {
        const images = await loadSliderImages();
        if (Array.isArray(images) && images.length > 0) {
          setSliderImages(images.map((img) => img.url));
        } else {
          setSliderImages(fallbackImages);
        }
      } catch {
        setSliderImages(fallbackImages);
      }
    };
    loadImages();
  }, []);

  const adImages = sliderImages.length > 0 ? sliderImages : fallbackImages;

  useEffect(() => {
    const t = setInterval(
      () => setAdIndex((i) => (i + 1) % adImages.length),
      3500
    );
    return () => clearInterval(t);
  }, [adImages.length]);

  // password visibility
  const [showPassword, setShowPassword]               = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreedToPolicy, setAgreedToPolicy]           = useState(false);

  const [form, setForm] = useState({
    firstName:     "",
    lastName:      "",
    dateOfBirth:   "",
    gender:        "",
    country:       "",
    emailPrefix:   "",
    password:      "",
    confirmPassword: "",
    recoveryEmail: "",
  });

  const email = useMemo(
    () =>
      form.emailPrefix
        ? `${form.emailPrefix.trim().toLowerCase()}${CORPORATE_DOMAIN}`
        : "",
    [form.emailPrefix]
  );

  // email availability check
  useEffect(() => {
    if (step !== 3) return;
    if (!form.emailPrefix || form.emailPrefix.length < 7) {
      setEmailAvailable(null);
      return;
    }
    const timer = setTimeout(async () => {
      try {
        setCheckingEmail(true);
        const res = await axios.post(`${SERVER_URL}/api/auth/check-email`, { email });
        setEmailAvailable(Boolean(res.data?.available));
      } catch {
        setEmailAvailable(false);
      } finally {
        setCheckingEmail(false);
      }
    }, 600);
    return () => clearTimeout(timer);
  }, [form.emailPrefix, email, step]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMessage("");
    if (name === "emailPrefix") {
      const cleaned = value
        .replace(/@.*$/, "")
        .replace(/[^a-zA-Z0-9._-]/g, "")
        .toLowerCase();
      setForm({ ...form, emailPrefix: cleaned });
      return;
    }
    setForm({ ...form, [name]: value });
  };

  const validateStep = (currentStep) => {
    switch (currentStep) {
      case 0: // Personal
        if (!form.firstName?.trim()) { setMessage("First name is required"); return false; }
        if (!form.lastName?.trim())  { setMessage("Last name is required");  return false; }
        return true;

      case 1: // Details
        if (!form.dateOfBirth) { setMessage("Date of birth is required"); return false; }
        if (!isAtLeast12YearsOld(form.dateOfBirth)) { setMessage("You must be at least 12 years old"); return false; }
        if (!form.gender)      { setMessage("Select gender");             return false; }
        if (!form.country)     { setMessage("Select your country");       return false; }
        return true;

      case 2: // Recovery email (optional — skip allowed)
        if (form.recoveryEmail && !/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(form.recoveryEmail)) {
          setMessage("Enter a valid recovery email address");
          return false;
        }
        if (form.recoveryEmail && form.recoveryEmail.toLowerCase() === email.toLowerCase()) {
          setMessage("Recovery email must be different from your login email");
          return false;
        }
        return true;

      case 3: // Email ID
        if (!form.emailPrefix)             { setMessage("Email ID is required");                        return false; }
        if (form.emailPrefix.length < 7)   { setMessage("Email user id must be at least 7 characters"); return false; }
        if (emailAvailable === false)       { setMessage("Email already exists");                        return false; }
        if (checkingEmail)                  { setMessage("Checking email availability...");              return false; }
        return true;

      case 4: // Password
        if (form.password.length < 6)              { setMessage("Password must be at least 6 characters"); return false; }
        if (form.password !== form.confirmPassword) { setMessage("Passwords do not match");                return false; }
        if (!agreedToPolicy)                       { setMessage("Please accept the Privacy Policy to continue"); return false; }
        return true;

      default:
        return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!validateStep(step)) return;

    if (step < STEP_COUNT - 1) {
      setStep(step + 1);
      return;
    }

    // Final submit
    try {
      setLoading(true);
      const res = await axios.post(`${SERVER_URL}/api/auth/register`, {
        email,
        password:      form.password,
        fullName:      `${form.firstName.trim()} ${form.lastName.trim()}`.trim(),
        dateOfBirth:   form.dateOfBirth,
        gender:        form.gender,
        country:       form.country,
        recoveryEmail: form.recoveryEmail || "",
      });

      setSuccess(true);
            
      const { token, user } = res.data;
      if (token && user) {
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(res.data));
        window.location.href = "/";
      } else {
        window.location.href = "/login";
      }
      //setTimeout(() => { window.location.href = "/login"; }, 7000);
    } catch (err) {
      setMessage(err.response?.data?.error || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => { if (step > 0) setStep(step - 1); };

  const stepLabels = ["Personal", "Details", "Recovery", "Email", "Password"];

  const renderStep = () => {
    switch (step) {
      // ── Step 0: Personal ────────────────────────────────────────────────────
      case 0:
        return (
          <>
            <label>First Name</label>
            <input
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              placeholder="Enter first name"
            />
            <label>Last Name</label>
            <input
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              placeholder="Enter last name"
            />
          </>
        );

      // ── Step 1: Details ──────────────────────────────────────────────────────
      case 1:
        return (
          <>
            <label>Date of Birth</label>
            <input
              type="date"
              name="dateOfBirth"
              value={form.dateOfBirth}
              onChange={handleChange}
              max={new Date(
                new Date().setFullYear(new Date().getFullYear() - 12)
              ).toISOString().split("T")[0]}
            />

            <label>Gender</label>
            <select name="gender" value={form.gender} onChange={handleChange}>
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>

            <label>Country</label>
           <Select
  classNamePrefix="country-select"
  options={countryOptions}
  placeholder="Search country..."
  value={countryOptions.find(
    (option) => option.value === form.country
  )}
  onChange={(selected) =>
    setForm({
      ...form,
      country: selected?.value || "",
    })
  }
  isSearchable
  isClearable
/>
          </>
        );

      // ── Step 2: Recovery Email ───────────────────────────────────────────────
      case 2:
        return (
          <>
            <label>Recovery Email <span style={{ fontWeight: 400, fontSize: 12, color: "#64748b" }}>(optional)</span></label>
            <p style={{ fontSize: 13, color: "#64748b", margin: "0 0 8px" }}>
              Used to recover your account if you lose access. Must be a different email address.
            </p>
            <input
              type="email"
              name="recoveryEmail"
              value={form.recoveryEmail}
              onChange={handleChange}
              placeholder="e.g. yourname@krivaone.com"
              autoComplete="off"
            />
            {form.recoveryEmail &&
              form.recoveryEmail.toLowerCase() === email.toLowerCase() && (
                <small style={{ color: "red" }}>
                  Recovery email must differ from your login email
                </small>
              )}
            <p style={{ fontSize: 12, color: "#94a3b8", marginTop: 8 }}>
              You can skip this step and add it later in Settings → Security.
            </p>
          </>
        );

      // ── Step 3: Email ID ─────────────────────────────────────────────────────
      case 3:
        return (
          <>
            <label>Email Address</label>
            <input
              name="emailPrefix"
              value={form.emailPrefix}
              onChange={handleChange}
              placeholder={`username${CORPORATE_DOMAIN}`}
              autoCapitalize="none"
            />
            {form.emailPrefix && form.emailPrefix.length < 7 && (
              <small style={{ color: "red" }}>
                Email user id must be at least 7 characters
              </small>
            )}
            {checkingEmail && (
              <small style={{ color: "#888" }}>Checking availability…</small>
            )}
            {emailAvailable === true && (
              <small style={{ color: "green" }}>✔ Email is available</small>
            )}
            {emailAvailable === false && (
              <small style={{ color: "red" }}>✘ Email already exists</small>
            )}
          </>
        );

      // ── Step 4: Password ─────────────────────────────────────────────────────
      case 4:
        return (
          <>
            <label>Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword
                  ? <AiOutlineEyeInvisible size={18} />
                  : <AiOutlineEye size={18} />}
              </span>
            </div>

            <label>Confirm Password</label>
            <div className="password-input-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="••••••••"
              />
              <span
                className="password-toggle"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword
                  ? <AiOutlineEyeInvisible size={18} />
                  : <AiOutlineEye size={18} />}
              </span>
            </div>

         <div
  style={{
    marginTop: 12,
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 13,
    color: "#475569",
  }}
>
  <input
    id="privacy-policy-checkbox"
    type="checkbox" style={{ marginTop: 20,width: 20}}
    checked={agreedToPolicy}
    onChange={(e) => setAgreedToPolicy(e.target.checked)}
  />

  <label htmlFor="privacy-policy-checkbox" style={{ margin: 0 }}>
    I agree to the{" "}
    <a
      href="/privacy-policy"
      target="_blank"
      rel="noreferrer"
      style={{
        color: "#2563eb",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </a>
  </label>
</div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Header />

      <div className="login-page">
        <div className="login-layout">

          {/* LEFT — slider */}
          <div className="ad-card">
            <div className="ad-media">
              <img
                src={adImages[adIndex]}
                alt="advertisement"
                className="ad-image"
              />
            </div>
          </div>

          {/* RIGHT — register form */}
          <div className="login-card">
            <center>
              <img src={brandLogo} className="imglogo" alt="Brand Logo" />
            </center>

            <h2 className="login-title">Create Account</h2>

            {/* Success box */}
            {success && (
              <div className="success-box">
                <h3>Registration Successful</h3>
                <p>Your account has been created successfully.</p>
                <p style={{ fontSize: 13, color: "#777" }}>
                  Redirecting to login…
                </p>
                <button
                  className="btn-primary"
                  style={{ marginTop: 12 }}
                  onClick={() => (window.location.href = "/login")}
                >
                  Go to Login
                </button>
              </div>
            )}

            {message && <div className="login-error">{message}</div>}

            {!success && (
              <form onSubmit={handleSubmit} className="login-form">
                {renderStep()}

                <div className="step-buttons">
                  {step > 0 && (
                    <button
                      type="button"
                      className="btn-secondary"
                      onClick={handleBack}
                    >
                      Back
                    </button>
                  )}
                  <button
                    type="submit"
                    className="btn-primary"
                    disabled={loading || checkingEmail}
                  >
                    {loading
                      ? "Please wait..."
                      : step === STEP_COUNT - 1
                      ? "Register"
                      : step === 2
                      ? "Skip / Next →"
                      : "Next →"}
                  </button>
                </div>
              </form>
            )}

            <div className="login-footer">
              <a href="/login">Already have an account? Login</a>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default RegisterPage;
